import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";

const getAllDataExports = async (page = 1, limit = 10) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/data-exports?page=${page}&limit=${limit}`;
  const result = await axios.get(url, config);
  return result.data;
};

const getDataExportById = async (id) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/data-exports/${id}`;
  const result = await axios.get(url, config);
  return result.data;
};

const deleteDataExport = async (id) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/data-exports/${id}`;
  const result = await axios.delete(url, config);
  return result.data;
};

const approveDataExport = async (id) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/data-exports/${id}/approve`;
  const result = await axios.post(url, {}, config);
  return result.data;
};

const rejectDataExport = async (id, reason = "") => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/data-exports/${id}/reject`;
  const result = await axios.post(url, { reason }, config);
  return result.data;
};

export {
  getAllDataExports,
  getDataExportById,
  deleteDataExport,
  approveDataExport,
  rejectDataExport,
};
